/**
 * Mapa de rutas → breadcrumbs.
 * Cada entrada define el trail completo para esa sección.
 * Se usa en GenericList (auto-detección por URL) y puede importarse
 * en páginas standalone como ConditionIvaTypeList.
 *
 * Formato de cada item: { label: string, path?: string }
 * El último item no lleva `path` (es la página actual).
 */

export const HOME = { label: 'Inicio', path: '/' };
export const PROVEEDORES = { label: 'Proveedores', path: '/supplier' };
export const FINANZAS = { label: 'Finanzas' };
const CATALOGOS = { label: 'Catálogos' };

export const breadcrumbsMap = {
  '/report':           [HOME, { label: 'Reportes' }],
  '/client':           [HOME, { label: 'Clientes' }],
  '/bill':             [HOME, { label: 'Facturación' }],
  '/buy':              [HOME, PROVEEDORES, { label: 'Compras' }],
  '/expense':          [HOME, FINANZAS, { label: 'Gastos' }],
  '/client-payment':   [HOME, { label: 'Pagos de Clientes' }],
  '/product':          [HOME, CATALOGOS, { label: 'Productos' }],
  '/price-list':       [HOME, FINANZAS, { label: 'Listas de Precios' }],
  '/supplier':         [HOME, { label: 'Proveedores' }],
  '/purchase-payment': [HOME, PROVEEDORES, { label: 'Pagos de Compras' }],
  '/empty-movement':   [HOME, PROVEEDORES, { label: 'Vacíos' }],
  '/market':           [HOME, CATALOGOS, { label: 'Mercados' }],
  '/condition-iva-type': [HOME, CATALOGOS, { label: 'Condición de IVA' }],
  '/category':         [HOME, CATALOGOS, { label: 'Categorías' }],
  '/bank':             [HOME, CATALOGOS, { label: 'Bancos' }],
  '/check':            [HOME, { label: 'Cheques' }],
  '/own-check':        [HOME, PROVEEDORES, { label: 'Cheques emitidos' }],
  '/user':             [HOME, { label: 'Usuarios' }],
  '/news':             [HOME, { label: 'Novedades' }],
  '/tutorials':        [HOME, { label: 'Tutoriales' }],
};
